/**
 * Einzeldatei- und ZIP-Download (client.md §11).
 */
import JSZip from "jszip";
import { get, pull, type ApiCtx } from "../api/client";

function base64ToBytes(b64: string): Uint8Array<ArrayBuffer> {
  const bin = atob(b64);
  const bytes = new Uint8Array(new ArrayBuffer(bin.length));
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Holt ein einzelnes Dokument über /get und löst einen Browser-Download aus. */
export async function downloadSingle(ctx: ApiCtx, docId: string): Promise<void> {
  const res = await get(ctx, docId);
  if (res.code < 0 || (!res.content && !res.content_base64)) {
    throw new Error(res.msg ?? `Dokument ${docId} konnte nicht geladen werden`);
  }
  const filename = res.filename ?? docId;
  const blob = res.is_image && res.content_base64
    ? new Blob([base64ToBytes(res.content_base64)])
    : new Blob([res.content_base64 ? atob(res.content_base64) : res.content ?? ""], { type: "text/plain;charset=utf-8" });
  triggerDownload(blob, filename);
}

/** Holt alle Dokumente über /pull, packt sie zu <workspace>.zip und startet den Download. */
export async function downloadAllAsZip(ctx: ApiCtx): Promise<number> {
  const res = await pull(ctx);
  if (res.code < 0) throw new Error(res.msg ?? "Dokumente konnten nicht geladen werden");
  const documents = res.documents ?? [];
  const zip = new JSZip();
  for (const doc of documents) {
    if (doc.content_base64) zip.file(doc.filename, base64ToBytes(doc.content_base64));
    else zip.file(doc.filename, doc.content ?? "");
  }
  const blob = await zip.generateAsync({ type: "blob" });
  triggerDownload(blob, `${ctx.workspace}.zip`);
  return documents.length;
}
